import { Brain, Database, Loader2, ScanText, Sparkles, Wand2 } from "lucide-react";

import type { LoadingState } from "@/components/ui/multi-step-loader";
import { MultiStepLoader } from "@/components/ui/multi-step-loader";

interface QuickProcessingOverlayProps {
  visible: boolean;
  states?: LoadingState[];
  title?: string;
  duration?: number;
  blur?: "none" | "sm" | "md" | "lg";
  loop?: boolean;
  subtitle?: string;
}

// Thin wrapper around MultiStepLoader to keep consistent look & feel
export default function QuickProcessingOverlay({
  visible,
  states,
  title = "Procesando con IA…",
  duration = 1400,
  blur = "md",
  loop = true,
  subtitle,
}: QuickProcessingOverlayProps) {
  const defaultStates: LoadingState[] = [
    { text: "El procesado puede tardar unos minutos…", icon: Loader2 },
    { text: "Leyendo y normalizando descripciones…", icon: ScanText },
    { text: "Traduciendo productos…", icon: Wand2 },
    { text: "Haciendo match con la base de productos…", icon: Database },
    { text: "Estimando cantidades y unidades…", icon: Sparkles },
    { text: "Detectando marcas y códigos…", icon: ScanText },
    { text: "Preparando sugerencias para revisión…", icon: Brain },
  ];

  return (
    <MultiStepLoader
      loading={visible}
      loadingStates={states ?? defaultStates}
      duration={duration}
      loop={loop}
      title={title}
      blur={blur}
      subtitle={
        subtitle ??
        "Estamos procesando con IA. Puede llevar un momento y quizás necesites ajustar algunos datos luego."
      }
    />
  );
}
